export default __webpack_public_path__ + "static/media/checkmark-danger.7df1c96a.svg";